import React from "react";
import useAuth from "../../../hooks/useAuth";
import TransactionIndividual from "../wallet/TransactionIndividual";
import InventoryIndividual from "../inventory-manager/InventoryIndividual";
import WithdrawModal from "../wallet/WithdrawModal";

const Backdrop = () => {
  const { backdrop, transactionIndividual, inventoryIndividual } = useAuth();
  return (
    <>
      {backdrop && (
        <div
          className={`font-Inter fixed h-screen w-screen 2xl:w-1500px bg-sellerhubBackdrop flex ${
            transactionIndividual.length > 0 || inventoryIndividual.length > 0
              ? "justify-end"
              : "justify-center items-center"
          }`}
        >
          {transactionIndividual.length > 0 ? (
            <TransactionIndividual />
          ) : inventoryIndividual.length > 0 ? (
            <InventoryIndividual />
          ) : (
            <WithdrawModal />
          )}
        </div>
      )}
    </>
  );
};

export default Backdrop;
